export default {
  loggedIn: false
};
